@if (item[field]) {
  <div class="comments-wrapper">
    <i class="fas fa-comment"></i>
    <span class="comments-number">1x</span>
  </div>
}
